import { render, staticRenderFns } from "./DriverMembership.vue?vue&type=template&id=48861470&"
import script from "./DriverMembership.vue?vue&type=script&lang=js&"
export * from "./DriverMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports